import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { NgModule } from '@angular/core';
import { AuthGuardService as AuthGuard } from './auth/services/auth-guard.service';
import { AuthGuardService } from 'auth';
import { UnauthorizedLandingComponent } from 'unauthorized-landing';
import { LmsActivitiesProcessFlowComponent } from './components/lms-activities-process-flow/lms-activities-process-flow.component';
import { ClaimCmeCeComponent } from './components/claim-cme-ce/components/claim-cme-ce.component';

import { FakeStoreComponent } from './components/fake-store/fake-store.component';

const appRoutes: Routes = [
  //{
    //path: '',
    //component: FakeStoreComponent,
    //canActivate: [AuthGuardService, AuthGuard],
    //runGuardsAndResolvers: 'always',
  //},
  // Newly added redirect route
  {
    path: '',
    component: ClaimCmeCeComponent,
    canActivate: [AuthGuardService, AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'fakestore',
    component: FakeStoreComponent,
    canActivate: [AuthGuardService, AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'labselector/:activityCode',
    component: LmsActivitiesProcessFlowComponent,
    canActivate: [AuthGuardService, AuthGuard],
    runGuardsAndResolvers: 'always',
  },
  {
    path: 'claim-cmece-credit-fax',
    component: ClaimCmeCeComponent,
    canActivate: [AuthGuardService, AuthGuard],
    // canActivate: [AuthGuard],
    // canActivate: [ClaimCmeCeGuard],
    runGuardsAndResolvers: 'always',
  },
  // { path: 'unauthorized', component: UnauthorizedLandingComponent },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      useHash: true,
      onSameUrlNavigation: 'reload',
      preloadingStrategy: PreloadAllModules,
      enableTracing: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
